import {FormAntecedentsModel} from './FormAntecedentsModel';

export class FormConducteurModel {
  civilite: string;
  nom: string;
  prenom: string;
  dateNaissance: string;
  datePermis: string;
  typePermis: string;
  isConduiteMaroc: any = false;
  isConduiteTunisie: any = false;
  isConduiteTurquie: any = false;
  isConduiteRussie: any = false;
  situationFamiliale: string;
  profession: string;
  adresse: string;
  codePostal: string;
  ville: string;
  tel: string;
  email: string;
  lienAvecConducteurPrincipal: string;
  antecedents: FormAntecedentsModel;

  constructor() {
    this.antecedents = new FormAntecedentsModel();
  }
}
